import ApiService from "@/common/api.service"

export const GraduateService = {
    importGenericEntry(params) {
        return ApiService.post("/pre-services/import", params);
    },
    updateImportedGraduate(slug, params) {
        return ApiService.update("/preservice/genericEntries", slug, params);
    },
    importPostBasic(params) {
        return ApiService.post("/pre-services/import", params);
    },
    importPostGraduate(params) {
        return ApiService.post("/pre-services/import", params);
    },
    importNimeiProgram(params) {
        return ApiService.post("/pre-services/import", params);
    },
    importStructuredPreService(params) {
        return ApiService.post("/pre-services/import", params);
    },

//
    async getPostServices(page, itemsPerPage, params) {
        const res = await ApiService.get(
            `/pre-services?page=${page}&pageSize=${itemsPerPage}${params}`
        );
        return res.data
    },
    findPreServiceStudentIdentity(idNo, options = {}) {
        const excludeIdQuery = options.excludeId ? `?excludeId=${options.excludeId}` : "";
        return ApiService.get(`/pre-services/student-identity/${idNo}${excludeIdQuery}`);
    },
    createPreService(params) {
        return ApiService.post("pre-services/add", params);
    },
    updatePreService(slug, params) {
        return ApiService.update("/pre-services", slug, params);
    },
}
